/**
 * @desc 通过pano获取详情
 */
const URL = "/rantion-business";
import http, { updateResponse } from "@/http";
export function request(pano: string, options?: any) {
  return updateResponse(
    http(URL + `/oms/paymentOrder/getByPano/${pano}`, {
      method: "GET",

      ...options,
    }),
  );
}
